export default "__VITE_ASSET__aHvX3KJ7__"